import { TypesenseProductsDocument } from 'shared-code/typesense/typesense.types'
import { DSCheckDetailsProductTags } from 'shared-definitions/types'

export function productTagsMapper(product: TypesenseProductsDocument): DSCheckDetailsProductTags {
  const MAX_TAGS_VISIBLE = 2

  return product.tags.length > MAX_TAGS_VISIBLE
    ? {
        list: product.tags.slice(0, MAX_TAGS_VISIBLE),
        postfix: '+' + (product.tags.length - MAX_TAGS_VISIBLE).toString(),
      }
    : {
        list: product.tags,
        postfix: '',
      }
}
